/* ------------------------------------------------------------------
   File: NewsroomArticle.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-05-10
------------------------------------------------------------------ */

import React from 'react'

function NewsroomArticle() {
  return (
    <div>
      NewsroomArticle Page
    </div>
  )
}

export default NewsroomArticle
